import { CookieConsentContext } from '@wienenergiegithub/modules-next/components';
import React from 'react';
import { Button } from '@wienenergiegithub/ui-next';
import PropTypes from 'prop-types';

const CmsCookieConsent = ({
  className,
  isAnimated = true,
  text,
  variant = 'default',
}) => (
  <CookieConsentContext.Consumer>
    {({ dialog }) => {
      const handleClick = () => {
        dialog.show();
      };
      return (
        <Button
          className={className}
          isAnimated={isAnimated}
          onClick={handleClick}
          theme="tertiary"
          variant={variant}
        >
          {text}
        </Button>
      );
    }}
  </CookieConsentContext.Consumer>
);

CmsCookieConsent.propTypes = {
  className: PropTypes.string,
  isAnimated: PropTypes.bool,
  text: PropTypes.string,
  variant: PropTypes.oneOf(['link', 'outline', 'bubble']),
};

export default CmsCookieConsent;
